/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';
import { DownloadDialogComponent } from './download-dialog.component';

export const downloadDialogRoute = createDialogRoute({
  component: DownloadDialogComponent,
});
